<template>
  <content-layout :title="title" :head-image="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div class="activity-item mgui-container" slot="/biding">
      <div class="filter-row">
        <div style="margin-bottom:10px">
          专业：<Input v-model="params.major" placeholder="专业技能" style="width:120px"></Input>
          部门:
          <Select v-model="params.department_id"  @on-change="fetchData" placeholder="选择项目组" style="width:100px">
            <Option value="all" label="All">All</Option>
            <template v-for="(item, ind) in $store.state.department">
            <Option :key="ind" :value="item.value" :label="item.label" v-if="item.value!=56" />
            </template>
          </Select>
          工龄：<Input v-model="params.min_work_year" placeholder="min" style="width:60px"></Input> - <Input v-model="params.max_work_year" placeholder="max" style="width:60px"></Input>
          性别：<Select v-model="params.gender" placeholder="性别" style="width:60px">
                <Option value="不限">不限</Option>
                <Option value="男">男</Option>
                <Option value="女">女</Option>
              </Select>
          年龄：<Input v-model="params.min_gender" placeholder="min" style="width:60px"></Input> - <Input v-model="params.max_gender" placeholder="max" style="width:60px"></Input>
          籍贯：<Input v-model="params.origin_place" placeholder="籍贯" style="width:100px"></Input>
          婚姻：<Select v-model="params.marital_status" @on-change="fetchData" placeholder="性别" style="width:60px">
                    <Option value="不限">不限</Option>
                    <Option value="已婚">已婚</Option>
                    <Option value="未婚">未婚</Option>
                  </Select>
          状态：<Select v-model="params.status" @on-change="fetchData" placeholder="性别" style="width:60px">
                    <Option value="all">All</Option>
                    <Option value="0">待审核</Option>
                    <Option value="1">待入职</Option>
                    <Option value="2">在职</Option>
                    <Option value="3">离职</Option>
                    <Option value="4">禁用</Option>
                  </Select>
          <Button icon="md-search" type="primary" @click="fetchData">筛选</Button>
          <Divider type="vertical" />
          <Button icon="md-create" type="success" @click="createData">添加</Button>
        </div>
        <div>
          下载：
          <BidingTemplate v-model="params.file"/>
          <Divider type="vertical" />
          <BidingDocument :disabled="params.file==''" :params="params"/>
          导入：
          <Divider type="vertical" />
          <Button icon="md-add" type="info" @click="importData">员工简历[导入/更新]到标书库</Button>
        </div>
      </div>
      <Table :columns="columns" @on-selection-change="checkboxChange" ref="userTable" :data="bidings.data"></Table>
      <div class="pager"><Page :total="bidings.total" show-sizer :page-size="parseInt(bidings.per_page)" :page-size-opts="[20,40,60,80,100]" @on-change="pagerChange" @on-page-size-change="pageSizeChange"></Page></div>
      <BidingForm  :visible.sync="editVisible" :data="data"/>
    </div>
    <div class="activity-item mgui-container" slot="/biding/course">
      <Row :gutter="16">
        <Col span="8">
          <Table :columns="fields_columns" :data="fields"></Table>
        </Col>
        <Col span="16">
          <h2>1.将左侧表格中字段按下图格式填入word文档(如下图) <a href="http://api.zjyumai.com/doc/template.docx" style="font-size:12px" target="_blank"><Icon type="md-download"/> 模版案例下载</a></h2>
          <br/>
          <img src="http://api.zjyumai.com/img/mb.jpg" style="width:100%;border:1px solid #eee;"/>
          <br/>
          <h2>2.返回“标书”卡片，上传模版下载</h2>
        </Col>
      </Row>
    </div>
  </content-layout>
</template>

<script>
  import {fetch, post} from '../fetch/api'

  const baseData = {
    edu_exp: {time: '', con: '', edu: '', major: ''},
    work_exp: {time: '', unit: '', post: '', reason: '', detail: ''},
    certificate: {name: '', time: '', unit: '', redord: '是'},
    contact: {name: '', relation: '', address: '', tel: '', email: ''},
    family: {name: '', relation: '', tel: '', unit: ''}
  }
  const defaultData = {
    id: 0,
    name: '',
    ename: '',
    birthday: '',
    gender: '',
    avatar: null,
    political_status: '',
    height: '',
    major: '',
    education: '',
    origin_place: '',
    reg_place: '',
    address: '',
    tel: '',
    email: '',
    mobile: '',
    id_number: '',
    marital_status: '',
    edu_exp: [baseData.edu_exp],
    work_exp: [baseData.work_exp],
    certificate: [baseData.certificate],
    contact: [baseData.contact],
    family: [baseData.family],
    remarks: ''
  }

  export default {
    name: 'Biding',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) },
      BidingDocument: resolve => { require(['../components/BidingDocument'], resolve) },
      BidingForm: resolve => { require(['../components/BidingForm'], resolve) },
      BidingTemplate: resolve => { require(['../components/BidingTemplate'], resolve) }
    },
    data () {
      return {
        title: '标书管理',
        headImage: '/static/images/bg/money.jpeg',
        activeTab: '/biding',
        tabs: [
          {'title': '标书', 'key': '/biding', 'visible': true},
          {'title': '教程', 'key': '/biding/course', 'visible': true}
        ],
        spinShow: true,
        params: {
          ids: [],
          page: 1,
          department_id: 'all',
          page_size: 20,
          major: '',
          file: '',
          min_work_year: 0,
          max_work_year: 0,
          gender: '不限',
          min_gender: 0,
          max_gender: 0,
          origin_place: '',
          status: 'all',
          marital_status: '不限'
        },
        bidings: {
          data: []
        },
        data: {
          name: '',
          ename: ''
        },
        ids: [],
        file: '',
        fields: [],
        fields_columns: [
          {
            title: '关键字',
            key: 'key'
          },
          {
            title: '描述',
            key: 'comment'
          },
          {
            title: '类型',
            key: 'type',
            align: 'right'
          }
        ],
        columns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          // {
          //   title: '头像',
          //   width: 80,
          //   key: 'name',
          //   render: (h, params) => {
          //     return h('div', [
          //       h('Avatar', {props: {src: `http://api.zjyumai.com/${params.row.avatar}`}})
          //     ])
          //   }
          // },
          {
            title: '姓名',
            width: 120,
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('div', params.row.name),
                h('div', params.row.ename)
              ])
            }
          },
          {
            title: '年龄',
            width: 100,
            key: 'year'
          },
          {
            title: '工龄',
            width: 100,
            key: 'work_year'
          },
          {
            title: '性别',
            key: 'gender',
            width: 60
          },
          {
            title: '婚姻',
            key: 'marital_status',
            width: 60
          },
          {
            title: '籍贯',
            width: 140,
            key: 'origin_place'
          },
          {
            title: '学历',
            width: 100,
            key: 'education'
          },
          {
            title: '专业',
            width: 120,
            key: 'major'
          },
          {
            title: ' '
          },
          {
            title: '状态',
            width: 100,
            render: (h, params) => {
              let status = ['待审核', '待入职', '在职', '离职', '禁用']
              let txt = '--'
              if (params.row.user) {
                txt = status[params.row.user.status]
              }
              return h('div', txt)
            }
          },
          {
            title: '操作',
            width: 160,
            render: (h, params) => {
              return h('div', [
                h('Button',
                  {
                    props: {
                      icon: 'ios-search',
                      type: 'success'
                    },
                    on: {
                      click: () => {
                        let data = JSON.parse(JSON.stringify(params.row))
                        data.edu_exp = data.edu_exp ? JSON.parse(data.edu_exp) : []
                        data.work_exp = data.work_exp ? JSON.parse(data.work_exp) : []
                        data.certificate = data.certificate ? JSON.parse(data.certificate) : []
                        data.contact = data.contact ? JSON.parse(data.contact) : []
                        data.family = data.family ? JSON.parse(data.family) : []
                        this.data = data
                        this.editVisible = true
                      }
                    }
                  }, '编辑')
              ])
            }
          }
        ],
        editVisible: false
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      this.routeChange(this.$route)
    },
    methods: {
      importData () {
        post('biding/import').then(res => {
          if (res.status === 'ok') {
            this.$Message.success('导入/更新成功')
            this.$Modal.remove()
            return
          }
          this.$Message.error('导入/更新失败')
          this.$Modal.remove()
        })
        this.$Modal.info({
          title: '导入',
          content: '正在导入 or 更新，请误关闭窗口'
        })
      },
      createData () {
        let data = JSON.parse(JSON.stringify(defaultData))
        this.data = data
        this.editVisible = true
      },
      checkboxChange (items) {
        this.ids = []
        this.params.ids = []
        for (let k in items) {
          this.ids.push(items[k].id)
          this.params.ids.push(items[k].id)
        }
        console.log(this.params.ids)
      },
      routeChange (route) {
        let action = route.params.action
        if (action === undefined) {
          this.fetchData()
          this.activeTab = '/biding'
        } else if (action === 'course') {
          this.activeTab = '/biding/course'
          this.fetchFields()
        }
      },
      pageSizeChange (size) {
        this.params.page_size = size
        this.fetchData()
      },
      pagerChange (page) {
        this.params.page = page
        this.fetchData()
      },
      fetchData () {
        fetch('biding', {params: this.params}).then(res => {
          if (res.status === 'ok') {
            this.bidings = res.data
          }
        })
        this.spinShow = false
      },
      fetchFields () {
        fetch('biding/fields').then(res => {
          if (res.status === 'ok') {
            this.fields = res.data
          }
        })
        this.spinShow = false
      }
    }
  }
</script>

<style scoped>

</style>
